// extracted by mini-css-extract-plugin
export default {"container":"CampaignDescription_container__Yvzl5","form":"CampaignDescription_form__8hYSy"};